import PropTypes from 'prop-types';
import { Reveal } from '@progress/kendo-react-animation';
import React, { useEffect, useState } from 'react';
import Header from './Header';

export default function Collapsable(props) {
  const [expanded, setExpanded] = useState(
    props.expanded === undefined ? true : props.expanded
  );

  useEffect(() => {
    if (props.expanded !== undefined) setExpanded(props.expanded);
  }, [props.expanded]);

  return (
    <div style={{ marginTop: '1rem' }}>
      <div
        style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
        onClick={() => {
          setExpanded(!expanded);
        }}
        data-testid='collapsable'
      >
        <Header
          style={{
            marginTop: '0.5rem',
            marginBottom: 0,
            color: '#007bff',
          }}
          title={props.title}
        />
        <span
          style={{
            color: '#007bff',
            fontSize: '1.5rem',
            marginLeft: 'auto',
            marginRight: '1rem',
          }}
          className={
            expanded
              ? 'k-icon k-font-icon k-i-arrow-chevron-down'
              : 'k-icon k-font-icon k-i-arrow-chevron-up'
          }
        />
      </div>

      <span
        style={{
          display: 'block',
          flex: '0 0 auto',
          color: '#007bff',
          borderBottom: '3px solid #007bff',
        }}
      ></span>
      <Reveal style={{ zIndex: 'inherit', width: '100%' }}>
        {expanded && props.children}
      </Reveal>
    </div>
  );
}

Collapsable.propTypes = {
  children: PropTypes.any,
  expanded: PropTypes.bool,
  title: PropTypes.string,
};
